import React from 'react';
import GerenciadorDeLicencas from 'pages/Usuarios/Components/GerenciadorDeLicencas';
import { Typography, Divider } from 'antd';

const { Title } = Typography;

const SelecaoLicencas = ({...props}) => {
  return (
    <div style={{ marginTop: '24px' }}>
      <Title level={4}>Selecione o Plano de E-mail</Title>
      <Divider />
      <GerenciadorDeLicencas {...props} />
    </div>
  );
};

export default SelecaoLicencas;